import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { LinkedinIcon, ArrowLeftIcon, BriefcaseIcon, AwardIcon } from 'lucide-react';
import { PageShell } from '../components/layout/PageShell';
import { GlassCard } from '../components/ui/GlassCard';
import { SmartImage } from '../components/common/SmartImage';
import { Button } from '../components/ui/Button';
import { useI18n } from '../lib/i18n';
import { TEAM } from '../lib/data';
export function TeamMember() {
  const {
    t,
    lang
  } = useI18n();
  const {
    memberId
  } = useParams();
  const member = TEAM.find(m => m.id === memberId);
  if (!member) {
    return <PageShell data-id="element-473" data-mp="2t6l9c9k4640k">
        <section className="mx-auto flex min-h-[50vh] max-w-lg flex-col items-center justify-center px-4 text-center" data-id="element-474" data-mp="2t6344nfh4fgi">
          <p className="text-lg text-silver/80" data-id="element-475" data-mp="2x6n1ns3yll36">Member not found.</p>
          <Link to="/journey" className="mt-6" data-id="element-476" data-mp="8gm0lxv8vqww">
            <Button data-id="element-477" data-mp="cih3h6stqccs">{t('back_to_journey')}</Button>
          </Link>
        </section>
      </PageShell>;
  }
  const bio = lang === 'en' ? member.bio_en : member.bio_am;
  return <PageShell data-id="element-478" data-mp="1qi7rm3dl9lgh">
      <section className="mx-auto max-w-3xl px-4 py-10 sm:px-6" data-id="element-479" data-mp="1llqtcgcodqpo">
        <Link to="/journey" className="inline-flex items-center gap-1.5 text-sm text-silver/70 hover:text-white" data-id="element-480" data-mp="1ljec65eqrkdo">
          <ArrowLeftIcon className="h-4 w-4" data-id="element-481" data-mp="1clc63bg5i1jj" />
          {t('back_to_journey')}
        </Link>

        <div className="mt-6 grid gap-6 md:grid-cols-[280px,1fr]" data-id="element-482" data-mp="17m7xalx525tq">
          <GlassCard className="overflow-hidden p-0" data-id="element-483" data-mp="17nj12lql3dku">
            <div className="aspect-square w-full overflow-hidden bg-white/5" data-id="element-484" data-mp="12ty8583ul9si">
              <SmartImage src={member.image} alt={member.name} className="h-full w-full object-cover" data-id="element-485" data-mp="xvd6r5cv0k2h" />
            </div>
            <div className="p-4" data-id="element-486" data-mp="ouynebjghf1m">
              <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-[rgba(217,217,217,0.25)] px-4 py-2.5 text-sm font-medium text-white hover:border-neon hover:text-neon" data-id="element-487" data-mp="ou6sz41lhncx">
                <LinkedinIcon className="h-4 w-4" data-id="element-488" data-mp="abr2xta3wr0" />
                LinkedIn
              </a>
            </div>
          </GlassCard>

          <div data-id="element-489" data-mp="58n2hcz82fbc">
            <h1 className="text-3xl font-extrabold text-white" data-id="element-490" data-mp="5a7v2x1z7o6k">
              {lang === 'en' ? member.name : member.name_am}
            </h1>

            <div className="mt-4 space-y-3" data-id="element-491" data-mp="xy40qr9iwqfh">
              <div className="flex items-start gap-3" data-id="element-492" data-mp="xx2ctm7es9gc">
                <BriefcaseIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-neon" data-id="element-493" data-mp="j97hdy20nqzk" />
                <div data-id="element-494" data-mp="j73enjfusy0v">
                  <p className="text-xs uppercase tracking-wide text-silver/50" data-id="element-495" data-mp="o80xly8otw3f">
                    {t('role')}
                  </p>
                  <p className="font-medium text-white" data-id="element-496" data-mp="1bwtv3z4ykc05">
                    {lang === 'en' ? member.role_en : member.role_am}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-497" data-mp="31e7duwnnzg2f">
                <AwardIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-neon" data-id="element-498" data-mp="31cnu2w2sumvw" />
                <div data-id="element-499" data-mp="2wfnosndrxo5u">
                  <p className="text-xs uppercase tracking-wide text-silver/50" data-id="element-500" data-mp="3a7avzi998h3e">
                    {t('expertise')}
                  </p>
                  <p className="font-medium text-white" data-id="element-501" data-mp="366s0ne85kswg">
                    {lang === 'en' ? member.expertise_en : member.expertise_am}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6" data-id="element-502" data-mp="2dimfwrh3n3wm">
              <h2 className="mb-2 text-lg font-semibold text-white" data-id="element-503" data-mp="2djed26qch9p0">
                {t('contributions')}
              </h2>
              <div className="space-y-3 leading-relaxed text-silver/80" data-id="element-504" data-mp="2mh887ecdhxal">
                {bio.map((p, i) => <p key={i} data-id="element-505" data-mp="6psoxd1b3e41" data-mpi={i}>{p}</p>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageShell>;
}